import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// Reduxのクーポンコードstate更新アクション
export const couponCodeAction = {
  updateCouponCode: actionCreator<string>("ACTIONS_UPDATE_COUPONCODE")
}

export default couponCodeAction
